import { api } from "@/lib/api";

/**
 * Share a stored file via the native share sheet (iPhone/iPad — Mail, WhatsApp,
 * AirDrop, Messages…). Falls back to downloading the file on desktop browsers.
 * Returns "shared" | "cancelled" | "downloaded".
 */
export async function shareOrDownloadFile(path, name) {
  const res = await api.get(`/files/${path}`, { responseType: "blob" });
  const blob = res.data;
  const fileName = name || path.split("/").pop();
  const file = new File([blob], fileName, { type: blob.type || "application/octet-stream" });

  if (navigator.canShare && navigator.canShare({ files: [file] })) {
    try {
      await navigator.share({ files: [file], title: fileName });
      return "shared";
    } catch (err) {
      if (err.name === "AbortError") return "cancelled";
      // fall through to download on unexpected share errors
    }
  }

  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 30000);
  return "downloaded";
}
